import http from '@/http-common'

export default {
    name: "LimitTab",
    props: {
        idLimit: {
            type: Number,
            default: null
        },
        typeName: {
            type: String,
            default: ''
        },
        typeNameRu: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            details: [],
            columnsDetail: [
                {key: 'typeName', label: 'typeName'},
                {key: 'limitSumma', label: 'Лимит суммы (руб.)'},
                {key: 'comment', label: 'Комментарий'},
                {key: 'edit_field', label: ''}
            ],
            typeList: [],
            countRecord: 0,
            isBusy: false
        }
    },
    created() {
        this.loadDetails();
        this.loadSprItems()
    },
    methods: {
        loadDetails() {
            let vm = this;
            vm.details = []
            vm.isBusy = true
            http.get('/limit/details/' + vm.idLimit + '?type='+this.typeName)
                .then((response) => {
                    vm.details = response.data;
                    let nn = 1;
                    vm.details.forEach(function (x) {
                        x.num = nn;
                        nn++;
                    })
                })
                .catch((error) => console.log(error.response.data))
                .finally(() => {
                    vm.onFilteredDetail(vm.details)
                    vm.isBusy = false
                });
        },
        loadSprItems() {
            this.typeList = [];
            let vm = this;
            http.get('/option/' + this.typeName)
                .then((response) => {
                    vm.typeList = response.data
                })
                .catch((error) => console.log(error.message));
        },
        filterOption(item) {
            let nnRow = item.num
            let ids = this.details.filter(x => x.num !== nnRow).map(x => parseInt(x.typeId));
            if (ids.indexOf(parseInt(item.typeId)) >= 0) {
                alert('Указанная(-ый) ' + this.typeNameRu + ' уже в списке!')
                item.typeId = 0
            }
        },
        deleteFromDetail(item) {
            let typeId = item.typeId
            const index = this.details.map(e => e.typeId).indexOf(typeId);
            if (index >= 0) {
                this.details.splice(index, 1)
            }
            this.onFiltered(this.details)
        },
        onFilteredDetail(filteredItems) {
            this.countRecord = filteredItems.length;
        },
        addToDetail() {
            let nn = 1;
            if (this.details.length > 0) {
                let detLast = this.details[this.details.length - 1];
                nn = detLast.num + 1
            }
            let detail = {typeId: 0, num: nn}
            let ids = this.details.filter(x => x.num !== nn).map(x => x.typeId);
            if (ids.indexOf(detail.typeId) >= 0) {
                alert('Пустая строка уже есть в списке!')
            } else {
                this.details.push(detail)
                this.onFilteredDetail(this.details)
            }
        }
    }
}
